import { validationIsEqual } from '../status';
import { validateAlphaNumericString, validateName, validateNumericString, validateSelection } from '@om/validation';
import {
    AGENT_NAME_SET_VALUE,
    AGENT_CODE_SET_VALUE,
    setNameValid,
    setAgentCodeValid,
} from '../../../actions/travelUg/agentModal';

let prevValidationAction = null;

export const agentModalFormValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;

        const validateString = (value, min, subject) => {
            const validators = [validateName, validateAlphaNumericString, validateNumericString];

            let customError = null;

            for (const validate of validators) {
                customError = validate(value, { min, subject });
                if (!customError) break;
            }

            return customError;
        };

        switch (action.type) {
            case AGENT_NAME_SET_VALUE:
                error = validateSelection(action.value, {
                    min: 1,
                    subject: 'Name',
                });
                return setNameValid(error);

            case AGENT_CODE_SET_VALUE:
                error = validateString(action.value, {
                    subject: 'Code',
                    min: 3,
                });
                return setAgentCodeValid(error);

            default:
                return null;
        }
    })();
    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
